import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { Children, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost, eramanHost } from "~/Utils";
import { post, put } from "~/Services";
import { useNotification } from "~/Hooks/useNotification";
import { CareersContent } from "./CareersContent";
import { JobOpportunities } from "./JobOpportunities/JobOpportunities";

export const Careers = () => {
  const query = useQuery();
  const { openToast } = useNotification();
  const navigate = useNavigate();

  const aboutEramanChildItems = [
    {
      label: "Content",
      key: 'careersContent',
      children: <CareersContent/>
    },
    {
      label: "Job Opportunities",
      key: 'jobOpportunities',
      children: <JobOpportunities/>
    },
  ];

  return (
    // <ContentWrapper title={"About Eraman"}>
      <Tabs
      activeKey={query?.get("thirdChildActiveTab") || ""}
      items={aboutEramanChildItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
